export default __webpack_public_path__ + "static/media/Commander's Armguards of the Shining Sun.b8da0b68.jpg";